import util from '@bmp-vue/core/api/util'

const controller = 'PermissaoReferencia'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetByCodigoReferencia: function (dto) {
    return util.Axios.Get(controller + '/GetByCodigoReferencia', dto)
  },
  AddPermissoes: function (dto) {
    return util.Axios.Post(controller + '/Add', dto)
  },
})
